import { createRoute, useParams } from '@tanstack/react-router';
import { lazy } from 'react';
import { authenticatedRoute } from '../_authenticated';

const ContentEditPageLazy = lazy(() =>
  import('@/features/content/components/ContentFormPage').then((m) => ({
    default: () => {
      const { type, id } = useParams({
        from: '/_authenticated/content/$type/$id/edit',
      });
      return m.ContentFormPage({ mode: 'edit', schemaType: type, contentId: id });
    },
  })),
);

export const contentEditRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/content/$type/$id/edit',
  component: ContentEditPageLazy,
});
